<div class="main-content">
  <div class="login-card">
    <div class="header-row">
      <h3 class="dialog-title" style="margin: 0; font-size: 16px; font-weight: 600">
        Reset Password
      </h3>
    </div>

    <div class="login-content">
      <div *ngIf="isVerifying" class="verifying-box">
        <mat-spinner diameter="30"></mat-spinner>
        <p>Verifying link...</p>
      </div>

      <div *ngIf="!isVerifying && errorMessage" class="error-box">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <p>{{ errorMessage }}</p>
        <button mat-button class="link-btn" (click)="goToLogin()">Return to Login</button>
      </div>

      <div *ngIf="!isVerifying && successMessage" class="success-box">
        <mat-icon class="success-icon">check_circle_outline</mat-icon>
        <p>{{ successMessage }}</p>
        <button mat-raised-button color="primary" class="primary-cta" (click)="goToLogin()">Go to Login</button>
      </div>

      <form *ngIf="!isVerifying && isValidCode && !successMessage" #resetForm="ngForm" (ngSubmit)="onSubmit()" class="form">
        <h2 class="welcome-title">Create new password</h2>
        
        <div class="full-width mb-12">
          <label class="input-label">New Password <span class="required-star">*</span></label>
          <div class="custom-input-box" [class.error]="resetForm.submitted && (!newPassword || newPassword.length < 6)">
            <mat-icon class="prefix-icon">lock_outline</mat-icon>
            <input
              [type]="hidePassword ? 'password' : 'text'"
              placeholder="Enter new password"
              [(ngModel)]="newPassword"
              name="newPassword"
              required
              minlength="6"
            />
            <mat-icon class="eye-icon" (click)="hidePassword = !hidePassword">
              {{ hidePassword ? "visibility_off" : "visibility" }}
            </mat-icon>
          </div>
          <div class="error-msg" *ngIf="resetForm.submitted && !newPassword">
            Password is required
          </div>
          <div class="error-msg" *ngIf="resetForm.submitted && newPassword && newPassword.length < 6">
            Password must be at least 6 characters
          </div>
        </div>

        <div class="full-width mb-12">
          <label class="input-label">Confirm Password <span class="required-star">*</span></label>
          <div class="custom-input-box" [class.error]="resetForm.submitted && (!confirmPassword || newPassword !== confirmPassword)">
            <mat-icon class="prefix-icon">lock_outline</mat-icon>
            <input
              [type]="hideConfirmPassword ? 'password' : 'text'"
              placeholder="Confirm new password"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              required
            />
            <mat-icon class="eye-icon" (click)="hideConfirmPassword = !hideConfirmPassword">
              {{ hideConfirmPassword ? "visibility_off" : "visibility" }}
            </mat-icon>
          </div>
          <div class="error-msg" *ngIf="resetForm.submitted && newPassword !== confirmPassword">
            Passwords do not match
          </div>
        </div>

        <button type="submit" class="primary-cta" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Resetting...' : 'Reset Password' }}
        </button>
      </form>
    </div>
  </div>
</div>
